// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3zTnI","info":"Note_info__1l5zP","note":"Note_note__ACMQM","actions":"Note_actions__3KtST"};